import React from 'react';
import logComponent from '../../common/logComponent';

export default function defaultUnitIcon() {
  if (logComponent('defaultUnitIcon')) { console.debug('defaultUnitIcon render'); }

  return (
	<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	  viewBox="1 1 30 30" xmlSpace="preserve" preserveAspectRatio="xMidYMid slice" height="100%" width="100%">
	  <path id="square-u-solid" d="m4.607 0a4.611 4.611 0 0 0-4.607 4.607v23.036a4.611 4.611 0 0 0 4.607 4.607h23.036a4.611 4.611 0 0 0 4.607-4.607v-23.036a4.611 4.611 0 0 0-4.607-4.607zm6.911 9.79v8.638a4.607 4.607 0 0 0 9.214 0v-8.638a1.728 1.728 0 0 1 3.455 0v8.638a8.063 8.063 0 0 1-16.125 0v-8.638a1.728 1.728 0 0 1 3.455 0z" fill="#7c7a7a" />
	</svg>
  );
}